"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
const validationSchema = Yup.object().shape({
    title: Yup.string().required('title is required'),
    round_type_id: Yup.number().required('roundType is required'),
    stages: Yup.array().of(Yup.object().shape({
        status_strategy_id: Yup.string().required('final status calculation is required'),
        reviewers: Yup.array()
            .of(Yup.object().shape({
            notification_type_id: Yup.number().required('notification is required'),
        }))
            .min(1, 'Must have at least 1 member'),
        deadline: Yup.date()
            .nullable()
            .default(null)
            .min(new Date(), 'Can not choose date in the past'),
    })),
    instruction: Yup.string().max(2000, 'Character limit of 2000 reached'),
});
exports.default = validationSchema;
